import { Grid, Typography } from '@material-ui/core';
import { GrupoAcesso, Perfil } from 'common/genericTypes';
import { Button, LgSpace } from 'm2m.components';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'store';
import Participantes from './participantes';

const GrenciarParticipante: React.FC = () => {
  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const isUsuarioCadastroOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.CadastroOperacoes;
  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);
  const history = useHistory();

  return (
    <div style={{ marginRight: 40 }}>
      <Grid container justify={'space-between'} direction={'row'} alignItems={'center'}>
        <Typography variant="h1">{'Participantes'}</Typography>
        {(isUsuarioOperacoes || isUsuarioCadastroOperacoes) && !isUsuarioLeitura && (
          <Button variant="contained" color="primary" onClick={() => history.push(`/gerenciar/participantes/cadastro`)}>
            {'Novo Participante'}
          </Button>
        )}
      </Grid>
      <LgSpace />
      <Participantes />
      <LgSpace />
    </div>
  );
};

export default GrenciarParticipante;
